// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__sz_ce","header":"PatientQuestionnaire_header__37wdC","info":"PatientQuestionnaire_info__s7MS8"};